import { Box, Grid } from '@material-ui/core';
import { Button, StandardDialog, Tabs, createCurrencyField, createNumberFormatFieldNoDecimalsAndWithLimit } from '@roc/ui';
import { flowResult } from 'mobx';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { creditPullTierLabel } from '../../types/creditPullTiersTypes';
import { useCreditPullTiersSettingsStore } from '../../hooks/useCreditPullTiersStore';

interface TierSettingsDialogProps {
  open: boolean;
  onClose: () => void;
}

export const TierSettingsDialog = observer(({ open, onClose }: TierSettingsDialogProps) => {
  const { creditPullTiersStore } = useCreditPullTiersSettingsStore();
  const { tiers, tierFormStores } = creditPullTiersStore;
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    if (open) {
      setSelectedTab(0);
      creditPullTiersStore.fetchAllTiers();
    }
  }, [open]);

  const tabs = tiers.map(tier => ({ label: creditPullTierLabel[tier.tier] }));

  const handleSave = async () => {
    for (let i = 0; i < tierFormStores.length; i++) {
      const isValid = tierFormStores[i].runFormValidationWithMessage();
      if (!isValid) {
        setSelectedTab(i);
        return;
      }
    }
    const success = await flowResult(creditPullTiersStore.bulkUpdateTiers());
    if (success) {
      onClose();
    }
  };

  const dialogContent = (
    <>
      <Tabs
        tabs={tabs}
        selectedTab={selectedTab}
        onTabChange={(e, index) => setSelectedTab(index)}
      />
      {tierFormStores.map((formStore, index) =>
        selectedTab === index && (
          <Box key={tiers[index].tier} pt={2}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {createNumberFormatFieldNoDecimalsAndWithLimit({
                  store: formStore,
                  testId: `includedPulls-${tiers[index].tier}`,
                  fieldName: 'includedPulls',
                  label: 'Included Pulls Per Month',
                })}
              </Grid>
              <Grid item xs={12}>
                {createCurrencyField({
                  store: formStore,
                  testId: `unitPrice-${tiers[index].tier}`,
                  fieldName: 'unitPrice',
                  label: 'Overage: Pricing Per Unit',
                })}
              </Grid>
            </Grid>
          </Box>
        )
      )}
    </>
  );

  const dialogActions = (
    <Box display="flex" justifyContent="flex-end" width="100%">
      <Button
        variant="outlined"
        color="primary"
        onClick={onClose}
        testId="tierSettingsCancelButton"
        style={{ marginRight: 8 }}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={handleSave}
        testId="tierSettingsSaveButton"
      >
        Save
      </Button>
    </Box>
  );

  return (
    <StandardDialog
      open={open}
      title="Tier Settings"
      maxWidth="sm"
      fullWidth
      handleClose={onClose}
      dialogContent={dialogContent}
      dialogActions={dialogActions}
    />
  );
});
